// extracted by mini-css-extract-plugin
export default {"primaryColor":"#c00","primaryColorWithAlpha":"rgba(247,93,190,.1019607843)","mainBgColor":"#000","secondBgColor":"#12121a"};